// extracted by mini-css-extract-plugin
export default {"toast":"CustomToast_toast__L0BoK","toastError":"CustomToast_toastError__ftXVC","toastWarning":"CustomToast_toastWarning__aZwrw","toastClose":"CustomToast_toastClose__XF8Bn"};